export default __webpack_public_path__ + "static/media/welcome.f87e52f0.svg";